export default "__VITE_ASSET__l3rjPQR1__"